import React from "react";
import { Link } from "react-router-dom";
import "./people.css";

import prof from "../../assets/images/dummy_profile.jpg";

function People({ className, peopleData }) {
  console.log(peopleData);
  return (
    <React.Fragment>
      <div
        className={`people_profile_search relative flex w-full py-4 px-3 rounded-xl bg-white ${className}`}
      >
        <div className="people_profile_search_image w-16 h-16 rounded-full overflow-hidden mr-3">
          <a href={`https://wisemonkeys.info/${peopleData.username}`}>
            <img src={peopleData.profile_photo} alt="prof" className="" />
          </a>
        </div>
        <div className="people_description flex flex-col">
          <div className="people_name flex items-center mb-1">
            <a
              href={`https://wisemonkeys.info/${peopleData.username}`}
              className="flex items-center"
            >
              <p className="mb-0 text-black mr-3 text-sm font-semibold userName relative">
                {peopleData.full_name}
              </p>
              <span className="text-xs text-gray-400">
                @{peopleData.username}
              </span>
            </a>
          </div>
          <div className="people_bio text-sm text-gray-400">
            {peopleData.description}
          </div>
          {peopleData.mutual_connections.length > 0 && (
            <div className="mutualFriendsWrapper flex items-center mt-3">
              <div className="mutualPersonImages flex">
                {peopleData.mutual_connections
                  .slice(0, 3)
                  .map((mutualData, idx) => {
                    return (
                      <img
                        key={idx}
                        src={mutualData.profile_photo}
                        alt="prof"
                        className="w-8 h-8 rounded-full"
                      />
                    );
                  })}
              </div>
              <span className="text-xs text-gray-400 block ml-2">
                {peopleData.mutual_connections_count} mutual connections
              </span>
            </div>
          )}
        </div>
        {peopleData.following_status === "SELF" ? (
          ""
        ) : peopleData.following_status ? (
          <button className="px-3 py-1 bg-color-2 text-white rounded-2xl followBtnSearch">
            Unfollow
          </button>
        ) : (
          <button className="px-3 py-1 bg-color-2 text-white rounded-2xl followBtnSearch">
            Follow
          </button>
        )}
      </div>
    </React.Fragment>
  );
}

export default People;
